import {Component, Input} from '@angular/core';

@Component({
  selector: 'configuration-segment',
  imports: [],
  templateUrl: './segment.component.html',
  styleUrl: './segment.component.scss'
})
export class SegmentComponent {
  @Input() title: string = "Title";
  @Input() description: string = "Description";
  @Input() useDefaultTitle: boolean = true;

  protected readonly document = document;
}
